// PolicyPage.jsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import Navbar from "../core/Navbar";
import Footer from "../core/Footer";

export const PolicyPage = () => {
  return (
    <div
      className="policy-page bg-light"
      style={{ minHeight: "100vh" }}
    >
      <Navbar />

      <Container className="py-5">
        <Row className="justify-content-center">
          <Col
            xs={12}
            md={10}
            lg={8}
          >
            <Card className="shadow-sm">
              <Card.Body>
                <h1 className="mb-3">Privacy Policy – High1 Digital</h1>

                <div className="mb-3 text-muted">
                  High1 Digital (“we”, “our”, “us”) is committed to protecting
                  your privacy. This policy explains how we collect, use, and
                  safeguard your information when you use our website and
                  services.
                </div>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>1. Information We Collect</h5>
                  <p>
                    We may collect the following information when you interact
                    with our website or services:
                  </p>
                  <ul>
                    <li>Name, Email, Phone Number</li>
                    <li>Business Name, Address, GST No.</li>
                    <li>Calendar booking details</li>
                    <li>Payment-related information (processed securely)</li>
                    <li>
                      Basic device &amp; usage data (IP, browser type, pages
                      visited)
                    </li>
                  </ul>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>2. How We Use Your Information</h5>
                  <p>We use your information to:</p>
                  <ul>
                    <li>Provide our SaaS services</li>
                    <li>Process payments &amp; send invoices</li>
                    <li>
                      Send important updates, reminders &amp; support
                      communication
                    </li>
                    <li>Improve website performance and user experience</li>
                    <li>Prevent fraud or misuse of our platform</li>
                  </ul>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>3. Payment Processing</h5>
                  <p>We use secure platforms to process payments.</p>
                  <ul>
                    <li>We do not store your card or UPI details.</li>
                    <li>All payment information is handled securely</li>
                  </ul>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>4. Sharing of Information</h5>
                  <p>
                    We do not sell your data.
                    <br />
                    Information may be shared only with trusted third-party
                    tools such as:
                  </p>
                  <ul>
                    <li>Hosting &amp; CRM services</li>
                    <li>Communication platforms (Email/SMS/WhatsApp)</li>
                  </ul>
                  <p>Only the minimum required data is shared.</p>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>5. Cookies</h5>
                  <p>
                    We use cookies to improve site functionality and user
                    experience.
                    <br />
                    You may disable cookies in your browser settings.
                  </p>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>6. Data Protection</h5>
                  <p>
                    We use reasonable security measures such as SSL and secure
                    servers.
                    <br />
                    However, no online transmission is 100% secure.
                  </p>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>7. Your Rights</h5>
                  <p>
                    You may request access, correction, or deletion of your data
                    anytime at:
                    <br />
                    📩{" "}
                    <a href="mailto:support@high1digital.com">
                      support@high1digital.com
                    </a>
                  </p>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-4">
                  <h5>8. Policy Updates</h5>
                  <p>
                    We may update this policy as required. Changes will be
                    posted here.
                  </p>
                </section>

                <div className="my-3">
                  <div className="sep">
                    ________________________________________
                  </div>
                </div>

                <section className="mb-0">
                  <h5>9. Contact Us</h5>
                  <p>
                    For any questions regarding this Privacy Policy:
                    <br />
                    High1 Digital
                    <br />
                    📩 Email:{" "}
                    <a href="mailto:support@high1digital.com">
                      support@high1digital.com
                    </a>
                    <br />
                    🌐{" "}
                    <a
                      href="https://high1digital.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://high1digital.com/
                    </a>
                  </p>
                </section>
              </Card.Body>
            </Card>

            <div className="text-center text-muted small mt-3">
              Last updated: {new Date().toLocaleDateString()}
            </div>
          </Col>
        </Row>
      </Container>

      {/* Inline small styling to keep file self-contained */}
      <style jsx>{`
        .sep {
          color: #d0d0d0;
          font-family: monospace;
          text-align: center;
          margin: 0.6rem 0;
        }
        .policy-page a {
          text-decoration: underline;
        }
        @media (max-width: 576px) {
          h1 {
            font-size: 1.4rem;
          }
        }
      `}</style>
      <Footer />
    </div>
  );
};

export default PolicyPage;
